import axios from "axios";

import { basePath, createHeaders } from "./utils";

/**
 * GET
 * /api/user
 *
 * Get All User For Org
 */

export const getUsers = () => {
  const config = {};
  config.headers = createHeaders();

  return new Promise((resolve, reject) => {
    axios
      .get(`${basePath}/user`, config)
      .then((resp) => {
        console.log("getUsers", resp);
        resolve(resp.data);
      })
      .catch((err) => {
        console.error(err);
        reject(err);
      });
  });
};

/**
 * PUT
 * /api/user
 *
 * Update a user [Described as "Add a new user" on Swagger-ui example]
 */

export const updateUser = (data) => {
  const config = {};
  config.headers = createHeaders();

  return new Promise((resolve, reject) => {
    axios
      .put(`${basePath}/user`, data, config)
      .then((resp) => {
        console.log("updateUser", resp);
        resolve(resp.data);
      })
      .catch((err) => {
        console.error(err);
        reject(err);
      });
  });
};

/**
 * POST
 * /api/user
 *
 * Add a new user
 */
export const postNewUser = (data) => {
  const config = {};
  config.headers = createHeaders();

  return new Promise((resolve, reject) => {
    axios
      .post(`${basePath}/user`, data, config)
      .then((resp) => {
        console.log("postNewUser", resp);
        resolve(resp.data);
      })
      .catch((err) => {
        console.error(err);
        reject(err);
      });
  });
};

/**
 * PUT
 * /api/user/password
 *
 * Change password for a user
 */

export const updatePassword = (data) => {
  const config = {};
  config.headers = createHeaders();

  return new Promise((resolve, reject) => {
    axios
      .put(`${basePath}/user/password`, data, config)
      .then((resp) => {
        console.log("updatePassword", resp);
        resolve(resp.data);
      })
      .catch((err) => {
        console.error(err);
        reject(err);
      });
  });
};

/**
 * GET
 * /api/user/{userId: string($uuid)}
 *
 * Get User by ID
 */
export const getUser = (userId) => {
  const config = {};
  config.headers = createHeaders();

  return new Promise((resolve, reject) => {
    axios
      .get(`${basePath}/user/${userId}`, config)
      .then((resp) => {
        console.log("getUser", resp);
        resolve(resp.data);
      })
      .catch((err) => {
        console.error(err);
        reject(err);
      });
  });
};

/**
 * GET
 * /api/user/role/types
 *
 * Returns all role types
 */
export const getUserRoleTypes = () => {
  const config = {};
  config.headers = createHeaders();

  return new Promise((resolve, reject) => {
    axios
      .get(`${basePath}/user/role/types`, config)
      .then((resp) => {
        console.log("getUserRoleTypes", resp);
        resolve(resp.data);
      })
      .catch((err) => {
        console.error(err);
        reject(err);
      });
  });
};

/**
 * GET
 * /api/user/phone/types
 *
 * Returns all phone types
 */
export const getUserPhoneTypes = () => {
  const config = {};
  config.headers = createHeaders();

  return new Promise((resolve, reject) => {
    axios
      .get(`${basePath}/user/phone/types`, config)
      .then((resp) => {
        console.log("getUserPhoneTypes", resp);
        resolve(resp.data);
      })
      .catch((err) => {
        console.error(err);
        reject(err);
      });
  });
};

/**
 * GET
 * /api/user/email/types
 *
 * Returns all email types
 */
export const getUserEmailTypes = () => {
  const config = {};
  config.headers = createHeaders();

  return new Promise((resolve, reject) => {
    axios
      .get(`${basePath}/user/email/types`, config)
      .then((resp) => {
        console.log("getUserEmailTypes", resp);
        resolve(resp.data);
      })
      .catch((err) => {
        console.error(err);
        reject(err);
      });
  });
};

/**
 * GET
 * /api/user/address/types
 *
 * Returns all address types
 */
export const getUserAddressTypes = () => {
  const config = {};
  config.headers = createHeaders();

  return new Promise((resolve, reject) => {
    axios
      .get(`${basePath}/user/address/types`, config)
      .then((resp) => {
        console.log("getUserAddressTypes", resp);
        resolve(resp.data);
      })
      .catch((err) => {
        console.error(err);
        reject(err);
      });
  });
};
